import { render, staticRenderFns } from "./TechnicalResponsibleMyValidations.vue?vue&type=template&id=f4703174&scoped=true&"
import script from "./TechnicalResponsibleMyValidations.vue?vue&type=script&lang=js&"
export * from "./TechnicalResponsibleMyValidations.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalResponsibleMyValidations.vue?vue&type=style&index=0&id=f4703174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4703174",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
